<template>
    <div class="image-display">
        <ul>
            <li v-for="(employee,index) in staff" :key="index" class="col-lg-4 col-md-4 col-sm-4 col-6">
                <img :src="employee.image" alt="">
                <b>{{employee.name}}</b>
                <p class="post">{{employee.position}}</p>
                <a class="post2" href="mailto:{{employee.website}}">{{employee.website}}</a>
            </li> 
        </ul>
    </div>
</template>

<script>
export default {
    name:'staff',
    props:{
        staff:{type:Array,required:true}
    }
}
</script>

<style scoped>
    .image-display{

    }
    .image-display ul{
        padding: 0px;
    }
    .image-display ul li{
        list-style: none;
        padding:0px;
        text-align: center;
        padding: 5px 5px;
        display:inline-block;
    }
    .image-display ul li img{
        max-height: 160px;
        display: block;
        margin:0 auto;
    }
    .image-display ul li b{

    }
    .image-display ul li p.post{
        font-size:small;
        margin-bottom:4px;
    }
    .image-display ul li p.post2{
        font-size:small;
        margin-bottom:0px;
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/staff.vue